export default {
	computed: {
		isRequired() {
			return this.fieldOptions?.required?.enabled;
		},
	},
};
